import { useEffect, useState } from 'react';
import * as microsoftTeams from '@microsoft/teams-js';

export default function TeamsAuthEnd() {
  const [message, setMessage] = useState<string>('Finalizing Microsoft Teams authentication...');

  useEffect(() => {
    async function run() {
      try {
        await microsoftTeams.app.initialize();

        const params = new URLSearchParams(window.location.search);
        const error = params.get('error') || params.get('message');

        if (error) {
          setMessage(`Authentication failed: ${error}`);
          microsoftTeams.authentication.notifyFailure(error);
        } else {
          setMessage('Authentication succeeded. You can close this window.');
          microsoftTeams.authentication.notifySuccess('ok');
        }
      } catch (e: any) {
        const msg = e?.message || 'Failed to complete Teams authentication';
        setMessage(msg);
        try {
          microsoftTeams.authentication.notifyFailure(msg);
        } catch {
          // ignore
        }
      }
    }
    run();
  }, []);

  return (
    <div style={{ minHeight: '60vh', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 24 }}>
      <div style={{ maxWidth: 520, textAlign: 'center' }}>
        <h3 style={{ marginBottom: 12 }}>Microsoft Teams Authentication</h3>
        <p style={{ color: '#666' }}>{message}</p>
      </div>
    </div>
  );
}
